<template>
    <footer class="hero is-small is-background-dark3" id="footer">
        <div class="hero-body">
            <div class="container">
                <div class="level">
                    <div class="level-right">
                        <div class="columns">

                            <!-- Column one -->
                            <div class="column is-narrow has-padding-2x footer-column">
                                <ul>
                                    <li>
                                        <p class="footer-title" active-class="is-active">
                                            {{$t('common:footer.advertisers') }}
                                        </p>
                                    </li>
                                    <li>
                                        <a href="https://panel.uptin.app/" class="footer-item text-white" rel="noopener">
                                            {{ $t('common:header.login') }}
                                            </a>
                                    </li>
                                    <li>
                                        <a href="https://panel.uptin.app/signup" class="footer-item text-white" rel="noopener">
                                            {{ $t('common:header.register') }}
                                        </a>
                                    </li>
                                    <li>
                                        <router-link :to="'tariff'" class="footer-item text-white" active-class="is-active">
                                            {{ $t('common:footer.tariff') }}
                                        </router-link>
                                    </li>
                                </ul>
                            </div>

                            <!-- Column two -->
                            <div class="column is-narrow has-padding-2x footer-column">
                                <ul>
                                    <li>
                                        <p class="footer-title" active-class="is-active">
                                            {{$t('common:footer.endـusers') }}
                                        </p>
                                    </li>

                                    <li>
                                        <router-link :to="'get-app'" class="footer-item text-white" active-class="is-active">
                                            {{ $t('common:footer.application_android') }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="'rules'" class="footer-item text-white" active-class="is-active">
                                            {{$t('common:footer.user_rules') }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="'contact-us'" class="footer-item text-white" active-class="is-active">
                                            {{$t('common:footer.report_vulnerability') }}
                                        </router-link>
                                    </li>
                                </ul>
                            </div>

                            <!-- Column three -->
                            <div class="column is-narrow has-padding-2x footer-column">
                                <ul>
                                    <li>
                                        <p class="footer-title" active-class="is-active">
                                            {{$t('common:footer.solutions') }}
                                        </p>
                                    </li>

                                    <li>
                                        <router-link :to="'healthcare'" class="footer-item text-white" active-class="is-active">{{
                                            $t('common:footer.healthcare') }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="'hospitality'" class="footer-item text-white" active-class="is-active">
                                            {{ $t('common:footer.hospitality') }}
                                        </router-link>
                                    </li>
                                </ul>
                            </div>

                            <!-- Column four -->
                            <div class="column is-narrow has-padding-2x footer-column">
                                <ul>
                                    <li>
                                        <p class="footer-title" active-class="is-active">
                                            {{$t('common:footer.the_organization') }}
                                        </p>
                                    </li>

                                    <li>
                                        <router-link :to="'about-us'" class="footer-item text-white" active-class="is-active">{{
                                            $t('common:footer.about_viral') }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="'manifesto'" class="footer-item text-white" active-class="is-active">
                                            {{ $t('common:footer.manifesto') }}
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="'contact-us'" class="footer-item text-white" active-class="is-active">
                                            {{$t('common:footer.contact_us') }}
                                        </router-link>
                                    </li>

                                </ul>
                            </div>

                            <!-- Column five -->
                            <div class="column is-narrow has-padding-2x footer-column">
                                <ul>
                                    <li>
                                        <p class="footer-title" active-class="is-active">
                                            {{$t('common:footer.connection') }}
                                        </p>
                                    </li>
                                    <li v-if="isPersian(currentLocale)">
                                        <a href="https://virgool.io/uptinptt" class="footer-item text-white" rel="noopener">
                                            {{ $t('common:footer.blog') }}
                                        </a>
                                    </li>
                                    <li>
                                        <router-link :to="'faq'" class="footer-item text-white" active-class="is-active">
                                            {{$t('common:footer.faq') }}
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="level-left" v-if="isPersian(currentLocale)">
                        <div class="column is-narrow has-padding-2x footer-column">
                            <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=206555&code=q3re32zHqSTfRNyrqrgX">
                                <img alt="Enamad sign" src="../assets/namad.svg" width="300" height="300">
                            </a>
                        </div>
                        <div class="column is-narrow has-padding-2x footer-column">
                            <img alt="Samandehi sign"
                                 src="../assets/samandehi.svg"
                                 id = 'nbqewlaosizprgvjesgtjzpe'
                                 style = 'cursor:pointer'
                                 onclick = 'window.open("https://www.uptin.app/application/samandehi.html", null, "width=450, height=600, scrollbars=no, resizable=yes")'
                                 width="300" height="300"
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="hero-footer has-padding-2x is-background-dark1">
            <div class="container padding-top-2x">
                <div class="columns is-mobile">
                    <div class="column">
                         <div class="navbar-item">
                            <a href="#" class="footer-logo"></a>
                        </div>
                    </div>
                </div>

                <div class="columns ">
                    <div class="column is-4 has-padding-2x">
                        <ul>
                            <li>
                                <div class="columns is-mobile footer-item">
                                    <div class="column text-white">
                                        {{ $t('common:footer.the_organization') }} ©️
                                        {{ $t('common:footer.made_with') }}
                                        <i class="fas fa-heart" style="color: #ff4b57;"></i>
                                        {{ $t('common:footer.in_iran') }}
                                    </div>
                                </div>
                             </li>
                            <li>
                                <div class="columns is-mobile footer-item" v-if="isPersian(currentLocale)">
                                    <div class="column text-white" style="max-width: min-content;">
                                        <i class="fas fa-map-marker-alt"></i>
                                    </div>
                                    <div class="column text-white">
                                        {{ $t('common:footer.address') }}
                                    </div>
                                </div>
                             </li>
                             <li>
                                 <div class="columns is-mobile footer-item" v-if="isPersian(currentLocale)">
                                    <div class="column text-white" style="max-width: min-content;">
                                        <i class="fas fa-building"></i>
                                    </div>
                                    <div class="column text-white">
                                        {{ $t('common:footer.postal_code') }}
                                    </div>
                                 </div>
                             </li>
                             <li>
                                  <div class="columns is-mobile footer-item" v-if="isPersian(currentLocale)">
                                    <div class="column text-white" style="max-width: min-content;">
                                        <i class="fas fa-phone"></i>
                                    </div>
                                    <div class="column text-white">
                                        {{ $t('common:footer.phone') }}
                                    </div>
                                 </div>
                             </li>
                            <li>
                                <div class="columns is-mobile footer-item" v-if="isPersian(currentLocale)">
                                    <div class="column text-white" style="max-width: min-content;">
                                        <i class="fas fa-fax"></i>
                                    </div>
                                    <div class="column text-white">
                                        {{ $t('common:footer.fax') }}
                                    </div>
                                </div>
                            </li>
                             <li>
                                <div class="columns is-mobile footer-item">
                                    <div class="column text-white" style="max-width: min-content;">
                                        <i class="fas fa-envelope"></i>
                                    </div>
                                    <div class="column text-white">
                                        {{ $t('common:footer.info') }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div class="column is-4">

                    </div>

                    <div class="column is-4 has-padding-2x">
                        <div class="columns is-mobile">
                            <a href="https://twitter.com/uptinptt" class="is-flex is-vcentered has-padding-1x" target="_blank" rel="noopener noreferrer">
                                        <span class="icon text-gray">
                                            <i class="fab fa-twitter"></i>
                                        </span>
                            </a>
                            <a href="https://www.linkedin.com/company/uptin" class="is-flex is-vcentered has-padding-1x"
                                target="_blank" rel="noopener noreferrer">
                                        <span class="icon text-gray">
                                            <i class="fab fa-linkedin-in"></i>
                                        </span>
                            </a>
                            <a href="https://www.instagram.com/uptin.app/" class="is-flex is-vcentered has-padding-1x"
                                target="_blank" rel="noopener noreferrer">
                                        <span class="icon text-gray">
                                            <i class="fab fa-instagram"></i>
                                        </span>
                            </a>
                        </div>
                        <div>
                            <form @submit.prevent="sendEmail" novalidate>
                            <p class="email-field" v-bind:class="{'submitted': emailSendClicked}">
                                <button class="submit-button is-android" type="submit"
                                        v-bind:class="{'success': subscribeSuccessful}">
                                    <span v-show="!emailSendClicked" class="uptin-text-center">
                                        {{ $t('common:footer.join') }}
                                    </span>
                                    <span v-show="emailSendClicked && !subscribeSuccessful"><i
                                        class="fas fa-spinner is-loading"></i></span>
                                    <span class="animated fadeIn" v-show="subscribeSuccessful"><i class="fas fa-check"></i></span>
                                </button>
                                <span class="input-email"
                                    v-bind:class="{'success': subscribeSuccessful}">
                                    <input class="input-field uptin-text-center"
                                        name="email"
                                        type="email"
                                        v-validate="'required|email'"
                                        :placeholder="$t('home:beta_container.email_placeholder')" v-model="email"
                                        v-bind:disabled="emailSendClicked">
                                </span>
                            </p>
                            <span
                                v-show="fields.email && fields.email.touched && errors.has('email')"
                                class="error-message has-text-danger is-size-7">
                                &nbsp;&nbsp; {{ $t('home:beta_container.field_needed') }}
                            </span>
                            <span class="error-message has-text-danger is-size-7" v-show="errorEmail">
                                &nbsp;&nbsp;{{errorEmail}}
                            </span>
                            <span class="success-message has-text-danger is-size-7" v-show="subscribeSuccessful">
                                <span
                                    v-html="$t('home:beta_container.success', { count: count + 1 })"></span>
                            </span>
                        </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<style lang="scss">
    .success-message {
        margin-top: 1em;
        font-weight: bold;
        display: inline-block;
    }

    .error-message {
        display: inline-block;
        margin-top: 1em;
    }

    .submitted {
        .submit-button {
            //top: 2px;

            @media(max-width: 768px) {
                top: 4px;
            }
        }
    ;
    }

    .waitlist-container{
        max-width: 500px;
    }

    .is-android {
        .submit-button {
            @media(max-width: 768px) {
                right: 0%;
                top: 0px !important;
            }

            .fa-paper-plane, .fa-paper-plane:focus {
                @media(max-width: 768px) {
                    left: -2px;
                }
            }

            .fa-check, .fa-spinner, .fa-check:focus, .fa-spinner:focus {
                @media(max-width: 768px) {
                    left: 0 !important;
                }
            }

        }

        .hero-footer {
            //margin-top: 20%;
        }
    }

    .submit-button {
        border-top-right-radius: 0.7em;
        border-bottom-right-radius: 0.7em;
        background: #ffbb00;
        position: absolute;
        right: 0;
        z-index: 2;
        width: 80px;
        min-height: 2.3em !important;
        border: none;
        color: #000000;
        cursor: pointer;
        outline: none;
        transition: right 1s;

        @media(max-width: 768px) {
            right: 0%;
            top: 0px;
        }

        &.success {
            // right: 50%;
        }

        .fa-spinner, .fa-check {
            font-size: 1.3em;
            position: relative;
            top: 1px;

            @media(max-width: 768px) {
                left: -6px;
            }
        }

        .fa-paper-plane {
            position: relative;
            left: -1px;

            @media(max-width: 768px) {
                left: -5px;
            }
        }

        &:hover {
            top: 0px;
            .fa-paper-plane {
                font-size: 1em;
            }

            @media(max-width: 768px) {
                top: 4px;
            }

            .fa-spinner, .fa-check {
                @media(max-width: 768px) {
                    left: -6px;
                }
            }
        }

        &:visited, &:focus {
            outline: none;
        }
    }

    .email-field {
        right: 0;
        position: relative;
        padding-right: 0%;

        @media(max-width: 768px) {
            padding: 0 0%;
        }
    }

    .input-email {
        overflow: visible !important;
        font-size: 0.98em;
        border-radius: 0.7em;
        width: 80%;
        right: 80px;
        min-height: 2.3em !important;
        transition: opacity 1s;

        input {
            text-align: center;
        }

        *:not(span) {
            position: relative;
            display: inherit;
            border-radius: inherit;
            margin: 0;
            border: none;
            outline: none;
            padding: 0.6em .525em;
            z-index: 1; // needs to be above the :focus span
            width: 100%;

            // summon fancy shadow styles when focussed
            &:focus + span {
                opacity: 1;
                transform: scale(1);
            }

            ::placeholder {
                color: #cbd0d5;
            }
        }

        span {

            transform: scale(.993, .94); // scale it down just a little bit
            transition: transform .5s, opacity .25s;
            opacity: 0; // is hidden by default

            position: absolute;
            z-index: 0; // needs to be below the field (would block input otherwise)
            margin: 10px; // a bit bigger than .input padding, this prevents background color pixels shining through
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            border-radius: inherit;
            pointer-events: none;
            animation: rainbow-shadow 10s infinite;
        }

        //&.success {
        //    opacity: 0;
        //}
    }

    .made-in-iran {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .footer-title {
        font-size: 14px;
        padding-bottom: 15px;
        color: #ffbb01;
    }

    .footer-column {
        width: 180px;
    }

    .footer-item {
        font-size: 12px;
    }

    .footer-logo {
        background-image: url('../assets/logo.webp');
        background-size: 75px 54px;
        background-repeat: no-repeat;
        background-position: center center;
        width: 75px;
        height: 54px;
    }

    .footer-logo-separator {
        width: 1px;
        height: 25px;
        background: #fafafa;
        margin-right: 8px;
        margin-left: 8px;
    }

</style>

<script>
    import axios from 'axios';

    const MAILCHIMP_SUBSCRIBE_URL = "https://api.uptin.app/api/v1/contact/newsletter/";

    export default {
        name: 'join-newsletter',
        data() {
            return {
                emailSendClicked: false,
                subscribeSuccessful: false,
                email: '',
                errorEmail: '',
                count: 0,
                currentLocale: this.$i18n.i18next.language || window.localStorage.i18nextLng
            }
        },

        methods: {
            postToMailChimp() {
                var data = new FormData();
                data.append('email', this.email);

                axios({
                    method: 'post',
                    url: MAILCHIMP_SUBSCRIBE_URL,
                    data: data,
                    headers: {
                        'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
                    }
                })
                .then((resp) => {
                    this.subscribeSuccessful = true;
                    this.errorEmail = '';
                    this.count = resp.data.count;
                })
                .catch((error) => {
                    if (error.response && error.response.status === 400) {
                        this.errorEmail = error.response.data;
                    } else {
                        this.errorEmail = this.$t('home:beta_container.server_error');
                    }
                    this.emailSendClicked = false;
                });
            },
            validateAll() {
                return this.$validator.validateAll().then((result) => {
                    this.touchAll();
                    return result && !this.subscribeSuccessful
                });
            },
            touchAll() {
                return Object.keys(this.fields).every(field => {
                    return this.fields[field].touched = true;
                });
            },
            sendEmail() {
                this.validateAll().then((result) => {
                    if (result) {
                        this.emailSendClicked = true;
                        this.postToMailChimp();
                    }
                });
            },
            isPersian(locale) {
                return locale.toLowerCase() === 'fa' || locale.toLowerCase() === 'ar';
            }
        },
    }
</script>
